export enum DiscountValidityPeriodType {
  Years = 0,
  Months = 1,
  Days = 2,
  FixedDates = 3,
}
